import type { DialogContentProps } from '@chakra-ui/react/dialog'
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
} from '@web/components/chakra-ui/dialog'
import { Portal } from '../Layout'

interface ModalProps {
  onClose: () => void
  id: string
  headerSlot?: React.ReactNode | React.ReactNode[]
  contentSlot: React.ReactNode | React.ReactNode[]
  footerSlot?: React.ReactNode | React.ReactNode[]
  withCloseButton?: boolean
  isOpen: boolean
  modalContentProps?: DialogContentProps
}

const Modal = ({
  onClose,
  id,
  headerSlot,
  contentSlot,
  footerSlot,
  withCloseButton = true,
  isOpen,
  modalContentProps,
}: ModalProps) => (
  <DialogRoot id={id} open={isOpen} onOpenChange={onClose}>
    <Portal>
      <DialogContent maxH="fit-content" maxW="fit-content" {...modalContentProps} backdrop={true}>
        {headerSlot && <DialogHeader justifyContent="center">{headerSlot}</DialogHeader>}
        {withCloseButton && <DialogCloseTrigger />}
        <DialogBody>{contentSlot}</DialogBody>

        {footerSlot && <DialogFooter justifyContent="center">{footerSlot}</DialogFooter>}
      </DialogContent>
    </Portal>
  </DialogRoot>
)

export { Modal }
